import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "base-signature-pad-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "base-signature-pad-label"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger dark:text-danger-dark ml-0.5"
}
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = { class: "base-signature-pad-overlay-text" }
const _hoisted_6 = { class: "base-signature-pad-controls" }
const _hoisted_7 = {
  key: 1,
  class: "base-signature-pad-hint"
}
const _hoisted_8 = {
  key: 2,
  class: "base-signature-pad-error"
}

import { onBeforeUnmount, onMounted, ref, watch, nextTick } from 'vue'
import SignaturePad from 'signature_pad'
import { Eraser } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSignaturePad',
  props: {
    modelValue: { default: '' },
    label: {},
    placeholder: { default: 'Sign here' },
    required: { type: Boolean, default: false },
    error: {},
    hint: {},
    width: { default: 600 },
    height: { default: 200 },
    penColor: { default: '#111827' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const canvasEl = ref<HTMLCanvasElement | null>(null)
let pad: SignaturePad | null = null
let strokeEndHandler: (() => void) | null = null

const hasValue = ref(false)

function syncFromModel() {
  if (!pad || !canvasEl.value) return
  if (props.modelValue) {
    pad.fromDataURL(props.modelValue)
    hasValue.value = true
  } else {
    pad.clear()
    hasValue.value = false
  }
}

function initPad() {
  if (!canvasEl.value) return

  canvasEl.value.width = canvasEl.value.offsetWidth || props.width
  canvasEl.value.height = props.height
  canvasEl.value.style.height = `${props.height}px`

  pad = new SignaturePad(canvasEl.value, {
    minWidth: 0.5,
    maxWidth: 2.5,
    penColor: props.penColor,
    backgroundColor: 'rgb(255,255,255)',
  })
  strokeEndHandler = () => {
    if (!pad) return
    hasValue.value = !pad.isEmpty()
    emit('update:modelValue', pad.isEmpty() ? '' : pad.toDataURL())
  }
  pad.addEventListener('endStroke', strokeEndHandler)
  syncFromModel()
}

function clear() {
  if (!pad) return
  pad.clear()
  hasValue.value = false
  emit('update:modelValue', '')
}

watch(() => props.modelValue, (value) => {
  if (!pad) return
  const current = pad.isEmpty() ? '' : pad.toDataURL()
  if (current !== value) {
    syncFromModel()
  }
})

watch(() => props.penColor, (color) => {
  if (pad && color) {
    pad.penColor = color
  }
})

watch(() => props.disabled, (val) => {
  if (pad) pad.enabled = !val
})

onMounted(() => {
  nextTick(() => {
    requestAnimationFrame(() => {
      initPad()
    })
  })
})

onBeforeUnmount(() => {
  if (pad && strokeEndHandler) {
    pad.removeEventListener('endStroke', strokeEndHandler)
    strokeEndHandler = null
  }
  pad = null
})

__expose({
  clear,
  isEmpty: () => (pad ? pad.isEmpty() : true),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["base-signature-pad-container", { 'has-error': _ctx.error, 'has-value': hasValue.value }])
    }, [
      _createElementVNode("canvas", {
        ref_key: "canvasEl",
        ref: canvasEl,
        class: _normalizeClass(["base-signature-pad-canvas", { 'has-error': _ctx.error }]),
        width: _ctx.width,
        height: _ctx.height
      }, null, 10, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass(["base-signature-pad-overlay", { 'is-hidden': hasValue.value }])
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.placeholder), 1)
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "base-signature-pad-clear",
          onClick: clear
        }, [
          _createVNode(_unref(Eraser), { class: "h-3.5 w-3.5" }),
          _cache[0] || (_cache[0] = _createTextVNode(" Clear "))
        ])
      ])
    ], 2),
    (_ctx.hint && !_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})